/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Library_Tab_ExercisesInputs */

const en_library_tab_exercises = /** @type {(inputs: Library_Tab_ExercisesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercises`)
};

const pl_library_tab_exercises = /** @type {(inputs: Library_Tab_ExercisesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ćwiczenia`)
};

/**
* | output |
* | --- |
* | "Exercises" |
*
* @param {Library_Tab_ExercisesInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const library_tab_exercises = /** @type {((inputs?: Library_Tab_ExercisesInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Library_Tab_ExercisesInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_library_tab_exercises(inputs)
	return en_library_tab_exercises(inputs)
});